<template>
  <div class="download-page">
    <section class="download-panel">
      <div class="download-copy">
        <p class="eyebrow">Download App</p>
        <h2>Scan to get the app</h2>
        <p class="description">Use the QR code below to download from Play Store or App Store.</p>
      </div>

      <div class="qr-box" aria-label="Sample QR code">
        <v-icon size="132" color="#111827">mdi-qrcode</v-icon>
      </div>

      <div class="store-actions">
        <button class="store-btn" type="button">
          <v-icon size="22">mdi-google-play</v-icon>
          <span>Download app Play Store</span>
        </button>

        <button class="store-btn" type="button">
          <v-icon size="22">mdi-apple</v-icon>
          <span>Download app App Store</span>
        </button>
      </div>
    </section>
  </div>
</template>

<style scoped lang="scss">
.download-page {
  padding: 32px 16px;
  color: #111827;
}

.download-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: min(100%, 420px);
  padding: 28px 20px;
  text-align: center;
  border-radius: 8px;
}

.download-copy h2 {
  margin: 4px 0 8px;
  font-size: 26px;
  line-height: 1.2;
  font-weight: 700;
}

.eyebrow {
  margin: 0;
  color: #e4572e;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: uppercase;
}

.description {
  max-width: 320px;
  margin: 0 auto;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

.qr-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 176px;
  height: 176px;
  margin: 24px 0;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
}

.store-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  width: 100%;
}

.store-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 12px 16px;
  color: #111827;
  font-weight: 700;
  line-height: 1.2;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
}


</style>
